(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
       // 获取分区元素及其ID
      const positionDiv = document.querySelector('.product-position-div.page-width');
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-collection-best-sellers"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-nc-best-sellers]').forEach((slider) => {
    if (slider.dataset.initialized === 'true') return;
    slider.dataset.initialized = 'true';
    const viewport = slider.querySelector('[data-nc-slider-viewport]');
    const cards = [...slider.querySelectorAll('.nc-best-sellers__card')];
    const dots = slider.querySelector('[data-nc-slider-dots]');
    if (!viewport || !dots || cards.length < 2) return;
    cards.forEach((card, index) => {
      const dot = document.createElement('span');
      dot.className = `nc-best-sellers__dot${index === 0 ? ' is-active' : ''}`;
      dots.appendChild(dot);
    });
    const update = () => {
      const viewportLeft = viewport.getBoundingClientRect().left;
      let activeIndex = 0;
      let distance = Infinity;
      cards.forEach((card, index) => {
        const nextDistance = Math.abs(card.getBoundingClientRect().left - viewportLeft - 16);
        if (nextDistance < distance) {
          distance = nextDistance;
          activeIndex = index;
        }
      });
      [...dots.children].forEach((dot, index) => dot.classList.toggle('is-active', index === activeIndex));
    };
    viewport.addEventListener('scroll', update, { passive: true });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-collection-category-navigation"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('new-collection-category-nav')) {
    customElements.define(
      'new-collection-category-nav',
      class extends HTMLElement {
        connectedCallback() {
          this.header = document.querySelector('sticky-header');
          this.headerSection = this.header?.closest('.section-header');
          this.updateHeaderOffset = this.updateHeaderOffset.bind(this);
          this.updateCompactState = this.updateCompactState.bind(this);
          this.updateHeaderOffset();
          this.resizeObserver = new ResizeObserver(this.updateHeaderOffset);
          if (this.header) this.resizeObserver.observe(this.header);
          this.headerStateObserver = new MutationObserver(this.updateHeaderOffset);
          if (this.headerSection) {
            this.headerStateObserver.observe(this.headerSection, {
              attributes: true,
              attributeFilter: ['class'],
            });
          }
          // The header slides in/out by transitioning `top` after the hidden
          // class flips. Scroll/mutation/transition events all fire before or
          // during the slide, never after it settles, so every wake-up starts
          // a short re-measure burst that ends only once the slide is done.
          this.headerTransitionHandler = this.updateHeaderOffset;
          if (this.headerSection) {
            this.headerSection.addEventListener('transitionend', this.headerTransitionHandler);
          }
          window.addEventListener('resize', this.updateHeaderOffset, { passive: true });
          window.addEventListener('scroll', this.updateCompactState, { passive: true });
          this.updateCompactState();
        }

        disconnectedCallback() {
          this.resizeObserver?.disconnect();
          this.headerStateObserver?.disconnect();
          if (this.headerSection) {
            this.headerSection.removeEventListener('transitionend', this.headerTransitionHandler);
          }
          window.removeEventListener('resize', this.updateHeaderOffset);
          window.removeEventListener('scroll', this.updateCompactState);
          if (this.settleRafId) cancelAnimationFrame(this.settleRafId);
        }

        requestSettleLoop() {
          this.settleFramesLeft = 18;
          if (this.settleRafId) return;
          const tick = () => {
            this.updateHeaderOffset();
            this.settleFramesLeft--;
            if (this.settleFramesLeft > 0) {
              this.settleRafId = requestAnimationFrame(tick);
            } else {
              this.settleRafId = null;
            }
          };
          this.settleRafId = requestAnimationFrame(tick);
        }

        getVisibleHeaderHeight() {
          if (!this.header) return 0;
          const isHeaderHidden = this.headerSection?.classList.contains('shopify-section-header-hidden');
          if (isHeaderHidden) return 0;
          // The header scrolls away with the page (it is not fixed), so it
          // only reserves space while part of it is still on screen.
          const rect = this.header.getBoundingClientRect();
          return rect.bottom > 0 ? rect.height : 0;
        }

        applyHeaderHeight(visibleHeight) {
          const px = `${Math.round(visibleHeight)}px`;
          this.style.setProperty('--nc-header-offset', px);
          document.documentElement.style.setProperty('--nc-header-height', px);
        }

        updateHeaderOffset() {
          this.applyHeaderHeight(this.getVisibleHeaderHeight());
          this.updateCompactState();
          this.requestSettleLoop();
        }

        updateCompactState() {
          if (!this.classList.contains('is-compact') && this.offsetHeight > 0) {
            this.style.minHeight = `${Math.ceil(this.offsetHeight)}px`;
          }
          // The in-flow header can leave the viewport on scroll without any
          // class change, so the scroll handler refreshes its height too.
          const visibleHeaderHeight = this.getVisibleHeaderHeight();
          this.applyHeaderHeight(visibleHeaderHeight);
          const shouldCompact = this.getBoundingClientRect().bottom <= visibleHeaderHeight;
          this.classList.toggle('is-compact', shouldCompact);
          // Expose the floating bar height so sticky siblings (e.g. the
          // collection filter sidebar) can clear it while it is pinned.
          const bar = this.querySelector('.nc-category-nav__bar');
          const floatingHeight = shouldCompact && bar ? Math.round(bar.getBoundingClientRect().height) : 0;
          document.documentElement.style.setProperty('--nc-float-nav-height', `${floatingHeight}px`);
          this.requestSettleLoop();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-collection-faq"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-nc-faq]').forEach((faq) => {
    if (faq.dataset.initialized === 'true') return;
    faq.dataset.initialized = 'true';

    faq.querySelectorAll('.nc-faq__item').forEach((item) => {
      const summary = item.querySelector('summary');
      const answer = item.querySelector('.nc-faq__answer');

      summary.addEventListener('click', (event) => {
        // 接管默认切换行为，先播放高度动画再修改 open
        event.preventDefault();
        if (item.classList.contains('is-animating')) return;

        const finish = () => {
          answer.style.height = '';
          answer.style.overflow = '';
          item.classList.remove('is-animating');
        };

        item.classList.add('is-animating');
        answer.style.overflow = 'hidden';

        if (item.open) {
          summary.setAttribute('aria-expanded', 'false');
          answer.style.height = answer.scrollHeight + 'px';
          void answer.offsetHeight; // 强制 reflow，确保起始高度被提交后再过渡
          answer.style.height = '0px';
          answer.addEventListener('transitionend', function handler(e) {
            if (e.propertyName !== 'height') return;
            answer.removeEventListener('transitionend', handler);
            item.open = false;
            finish();
          });
        } else {
          summary.setAttribute('aria-expanded', 'true');
          item.open = true;
          answer.style.height = '0px';
          void answer.offsetHeight; // 强制 reflow，确保起始高度被提交后再过渡
          answer.style.height = answer.scrollHeight + 'px';
          answer.addEventListener('transitionend', function handler(e) {
            if (e.propertyName !== 'height') return;
            answer.removeEventListener('transitionend', handler);
            finish();
          });
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-collection-product-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('new-collection-grid')) {
    customElements.define(
      'new-collection-grid',
      class extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;
          this.handleClick = this.handleClick.bind(this);
          this.handleChange = this.handleChange.bind(this);
          this.handleKeydown = this.handleKeydown.bind(this);
          this.handlePopState = this.handlePopState.bind(this);
          this.handlePointerOver = this.handlePointerOver.bind(this);
          this.handlePointerOut = this.handlePointerOut.bind(this);
          this.addEventListener('click', this.handleClick);
          this.addEventListener('change', this.handleChange);
          this.addEventListener('pointerover', this.handlePointerOver);
          this.addEventListener('pointerout', this.handlePointerOut);
          document.addEventListener('keydown', this.handleKeydown);
          window.addEventListener('popstate', this.handlePopState);
          this.initCards(this);
          this.insertPromos();
          this.initInfiniteScroll();
          this.initRevealObserver();
        }

        disconnectedCallback() {
          document.removeEventListener('keydown', this.handleKeydown);
          window.removeEventListener('popstate', this.handlePopState);
          this.removeEventListener('pointerover', this.handlePointerOver);
          this.removeEventListener('pointerout', this.handlePointerOut);
          this.destroyInfiniteScroll();
          this.destroyRevealObserver();
        }

        handleClick(event) {
          if (!event.target.closest('[data-nc-sort-popover]')) {
            this.closeSortMenu();
          }

          const openDrawer = event.target.closest('[data-nc-open-drawer]');
          if (openDrawer) {
            this.openDrawer(openDrawer);
            return;
          }

          if (event.target.closest('[data-nc-close-drawer]')) {
            this.closeDrawer(true);
            return;
          }

          if (event.target.closest('[data-nc-clear-draft]')) {
            this.clearDraft();
            return;
          }

          if (event.target.closest('[data-nc-apply-draft]')) {
            const mobileForm = this.querySelector('[data-nc-filter-form="mobile"]');
            this.closeDrawer(false);
            this.applyForm(mobileForm);
            return;
          }

          const sortToggle = event.target.closest('[data-nc-toggle-sort]');
          if (sortToggle) {
            const popover = sortToggle.closest('[data-nc-sort-popover]');
            const menu = popover && popover.querySelector('[data-nc-sort-menu]');
            const willOpen = menu.hasAttribute('hidden');
            menu.toggleAttribute('hidden', !willOpen);
            sortToggle.setAttribute('aria-expanded', String(willOpen));
            return;
          }

          const sortOption = event.target.closest('[data-nc-sort-value]');
          if (sortOption) {
            this.applySort(sortOption.dataset.ncSortValue);
            return;
          }

          const swatch = event.target.closest('[data-nc-variant-id]');
          if (swatch) {
            event.preventDefault();
            this.updateVariant(swatch);
            return;
          }

          const ajaxLink = event.target.closest('[data-nc-pagination-link], [data-nc-filter-link]');
          if (ajaxLink) {
            event.preventDefault();
            const targetUrl = new URL(ajaxLink.href, window.location.origin);
            // Preserve ?view=... alternate template when it's missing from the
            // server-printed url_to_remove / pagination href.
            const currentView = new URLSearchParams(window.location.search).get('view');
            if (currentView && !targetUrl.searchParams.has('view')) {
              targetUrl.searchParams.set('view', currentView);
            }
            this.renderFromUrl(targetUrl, true, true);
          }
        }

        handleChange(event) {
          if (event.target.matches('[data-nc-sort-select]')) {
            this.applySort(event.target.value);
            return;
          }
          const desktopForm = event.target.closest('[data-nc-filter-form="desktop"]');
          if (desktopForm) this.applyForm(desktopForm);
        }

        handleKeydown(event) {
          const drawer = this.querySelector('[data-nc-drawer]');
          if (event.key === 'Tab' && drawer && !drawer.hidden) {
            const focusable = [...drawer.querySelectorAll('button:not([disabled]), input:not([disabled]), select:not([disabled]), a[href], summary')]
              .filter((element) => element.offsetParent !== null);
            if (focusable.length) {
              const first = focusable[0];
              const last = focusable[focusable.length - 1];
              if (event.shiftKey && document.activeElement === first) {
                event.preventDefault();
                last.focus();
              } else if (!event.shiftKey && document.activeElement === last) {
                event.preventDefault();
                first.focus();
              }
            }
            return;
          }
          if (event.key !== 'Escape') return;
          if (drawer && !drawer.hidden) this.closeDrawer(true);
          this.closeSortMenu();
        }

        handlePopState() {
          this.renderFromUrl(new URL(window.location.href), false, false);
        }

        initCards(root) {
          const cards = root.querySelectorAll('[data-nc-product-card]');
          cards.forEach((card) => {
            if (card.dataset.ncCommittedVariantId) return;
            const activeSwatch = card.querySelector('[data-nc-variant-id].is-active');
            if (activeSwatch) {
              card.dataset.ncCommittedVariantId = activeSwatch.dataset.ncVariantId;
            }
          });
        }

        /**
         * Insert promo slots into the grid so that, counting visual cells
         * left-to-right / top-to-bottom across the WHOLE grid (initial page
         * plus every infinite-scroll page combined), each 18-cell group gets
         * a promo at position 7 and position 18. Because the grid is plain
         * CSS auto-placement, DOM order = visual order on desktop (3-col) and
         * mobile (2-col) alike, so index-based positions hold for both.
         *
         * `startIndex` marks cells that are already final (everything before
         * an append). The child at index i occupies global cell i + 1, so its
         * cycle position is (i % 18) + 1. Inserting a slot puts the promo in
         * cell i + 1 and shifts the current product to index i + 1, so simply
         * continuing the loop lands on the right next cell.
         *
         * The pool wraps: promo #n clones template n % poolSize, so the
         * merchant's promo_card blocks keep cycling through every group.
         */
        insertPromos(startIndex = 0) {
          const grid = this.querySelector('[data-nc-products-grid]');
          if (!grid) return;
          const templates = this.querySelectorAll('template[data-nc-promo-template]');
          if (!templates.length) return;
          let poolIndex = grid.querySelectorAll('.nc-promo-slot').length;
          for (let index = startIndex; index < grid.children.length; index++) {
            const cyclePos = (index % 18) + 1;
            if (cyclePos !== 7 && cyclePos !== 18) continue;
            const slot = templates[poolIndex % templates.length].content.firstElementChild.cloneNode(true);
            grid.insertBefore(slot, grid.children[index]);
            poolIndex++;
          }
        }

        handlePointerOver(event) {
          if (event.pointerType && event.pointerType !== 'mouse') return;
          const swatch = event.target.closest('[data-nc-variant-id]');
          if (!swatch) return;
          const card = swatch.closest('[data-nc-product-card]');
          const data = card?.querySelector('[data-nc-variants]');
          if (!card || !data) return;
          const variants = JSON.parse(data.textContent);
          const variant = variants.find((item) => String(item.id) === swatch.dataset.ncVariantId);
          if (!variant || !variant.image) return;
          const image = card.querySelector('[data-nc-product-image]');
          if (image) {
            image.src = variant.image;
            image.removeAttribute('srcset');
          }
          // Suppress the card's hover secondary-image swap so the previewed
          // primary image stays visible while hovering the swatch row.
          card.classList.add('is-variant-hover');
        }

        handlePointerOut(event) {
          if (event.pointerType && event.pointerType !== 'mouse') return;
          const swatch = event.target.closest('[data-nc-variant-id]');
          if (!swatch) return;
          if (swatch.contains(event.relatedTarget)) return;
          const card = swatch.closest('[data-nc-product-card]');
          const data = card?.querySelector('[data-nc-variants]');
          if (!card || !data) return;
          const committedId = card.dataset.ncCommittedVariantId;
          const variants = JSON.parse(data.textContent);
          const variant = committedId
            ? variants.find((item) => String(item.id) === committedId)
            : variants[0];
          if (variant && variant.image) {
            const image = card.querySelector('[data-nc-product-image]');
            if (image) {
              image.src = variant.image;
              image.removeAttribute('srcset');
            }
          }
          card.classList.remove('is-variant-hover');
        }

        applyForm(form) {
          if (!form) return;
          const params = new URLSearchParams(new FormData(form));
          // Remove parameters with empty values (e.g. unused price range inputs)
          for (const [key, value] of [...params.entries()]) {
            if (value === '' || value == null) params.delete(key);
          }
          // Preserve any alternate template suffix (?view=...) from the current URL
          const currentView = new URLSearchParams(window.location.search).get('view');
          if (currentView && !params.has('view')) params.set('view', currentView);
          this.renderFromUrl(new URL(`${this.dataset.collectionUrl}?${params.toString()}`, window.location.origin), true, true);
        }

        applySort(value) {
          const params = new URLSearchParams(window.location.search);
          params.set('sort_by', value);
          params.delete('page');
          // Clean any empty price parameters lingering in the current URL
          for (const [key, val] of [...params.entries()]) {
            if (val === '' || val == null) params.delete(key);
          }
          this.closeSortMenu();
          this.renderFromUrl(new URL(`${this.dataset.collectionUrl}?${params.toString()}`, window.location.origin), true, true);
        }

        async renderFromUrl(targetUrl, updateHistory, scrollToGrid) {
          if (this.controller) this.controller.abort();
          this.controller = new AbortController();
          this.classList.add('is-loading');
          this.setAttribute('aria-busy', 'true');
          const requestUrl = new URL(targetUrl);
          requestUrl.searchParams.set('section_id', this.dataset.sectionId);
          try {
            const response = await fetch(requestUrl, { signal: this.controller.signal });
            if (!response.ok) throw new Error(`Collection request failed: ${response.status}`);
            const html = await response.text();
            const nextDocument = new DOMParser().parseFromString(html, 'text/html');
            const nextGrid = nextDocument.querySelector('new-collection-grid');
            if (!nextGrid) throw new Error('Collection section was not returned');
            this.innerHTML = nextGrid.innerHTML;
            this.initCards(this);
            this.insertPromos();
            if (updateHistory) window.history.pushState({}, '', targetUrl);
            if (scrollToGrid) {
              // Scroll anchor = this entire section/component (from the left
              // filter sidebar down through the product grid), not just the
              // product list. Header-deduction, instant jump and double rAF
              // are kept so we reliably land below the sticky header right
              // after the DOM swap, not some arbitrary distance into results.
              const anchor = this;
              const doScroll = () => {
                try {
                  // Measure the max height of any full-width sticky / fixed
                  // header elements on the page. Do NOT filter by current
                  // viewport overlap: many themes slide the header off-screen
                  // on downward scroll (positioned with negative top), but it
                  // will re-appear as soon as we scroll UP toward the anchor,
                  // so we still need to reserve its height.
                  const vw = window.innerWidth;
                  const candidates = document.querySelectorAll(
                    'header, [class*="header"], [class*="Header"], [role="banner"]'
                  );
                  let headerPx = 0;
                  for (const el of candidates) {
                    const cs = getComputedStyle(el);
                    if (cs.position !== 'fixed' && cs.position !== 'sticky') continue;
                    const r = el.getBoundingClientRect();
                    if (r.width < vw * 0.8) continue;
                    const h = Math.round(r.height);
                    if (h > headerPx) headerPx = h;
                  }
                  // Fall back to the CSS var / inline style when the selector
                  // didn't match a non-standard header container.
                  if (!headerPx) {
                    const cs = getComputedStyle(this);
                    headerPx = parseFloat(cs.getPropertyValue('--nc-header-height')) || 0;
                  }
                  // Reserve room for the compact floating category nav plus
                  // the 40px sidebar gap, otherwise the sidebar title lands
                  // behind or flush against the floating nav after the jump.
                  const floatNavPx =
                    parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--nc-float-nav-height')) || 0;
                  const rect = anchor.getBoundingClientRect();
                  const targetY = Math.max(0, Math.round(rect.top + window.scrollY - headerPx - floatNavPx - 40));
                  window.scrollTo({ top: targetY, left: 0, behavior: 'auto' });
                } catch (e) {
                  try { anchor.scrollIntoView({ behavior: 'auto', block: 'start' }); }
                  catch (_) { /* no-op */ }
                }
              };
              requestAnimationFrame(() => requestAnimationFrame(doScroll));
            }
            this.initInfiniteScroll();
            this.initRevealObserver(true);
          } catch (error) {
            if (error.name !== 'AbortError') window.location.assign(targetUrl);
          } finally {
            this.classList.remove('is-loading');
            this.setAttribute('aria-busy', 'false');
          }
        }

        initInfiniteScroll() {
          this.destroyInfiniteScroll();
          this.loadingNextPage = false;

          const nav = this.querySelector('.nc-pagination');
          if (!nav) return;
          const nextLink = nav.querySelector('[data-nc-next-link]');

          // Hide pagination in the storefront (keep it visible as a clickable
          // fallback in the theme editor so merchants can verify page content).
          if (!(window.Shopify && window.Shopify.designMode)) nav.style.display = 'none';

          if (!nextLink) return;

          this.scrollHandler = () => {
            if (!this.scrollHandler) return;
            const sentinel = this.querySelector('[data-nc-products-grid]');
            if (!sentinel) return;
            const rect = sentinel.getBoundingClientRect();
            if (rect.bottom - window.innerHeight < 600) this.loadNextPage();
          };
          window.addEventListener('scroll', this.scrollHandler, { passive: true });
          // Initial check: in case the grid is already near the viewport bottom on load
          this.scrollHandler();
        }

        destroyInfiniteScroll() {
          if (this.scrollHandler) {
            window.removeEventListener('scroll', this.scrollHandler);
            this.scrollHandler = null;
          }
        }

        async loadNextPage() {
          if (this.loadingNextPage || !this.scrollHandler) return;
          const nav = this.querySelector('.nc-pagination');
          const nextLink = nav && nav.querySelector('[data-nc-next-link]');
          if (!nextLink) {
            this.destroyInfiniteScroll();
            return;
          }

          this.loadingNextPage = true;
          const loading = this.querySelector('[data-nc-loading-more]');
          if (loading) loading.hidden = false;
          const requestUrl = new URL(nextLink.href, window.location.origin);
          requestUrl.searchParams.set('section_id', this.dataset.sectionId);
          try {
            const response = await fetch(requestUrl, { signal: this.controller ? this.controller.signal : undefined });
            if (!response.ok) throw new Error(`Collection request failed: ${response.status}`);
            const html = await response.text();
            const nextDocument = new DOMParser().parseFromString(html, 'text/html');
            const nextGrid = nextDocument.querySelector('new-collection-grid');
            if (!nextGrid) throw new Error('Collection section was not returned');

            const grid = this.querySelector('[data-nc-products-grid]');
            const nextGridElement = nextGrid.querySelector('[data-nc-products-grid]');
            const nextNav = nextGrid.querySelector('.nc-pagination');
            if (!grid || !nextGridElement) throw new Error('Product grid was not returned');

            // Capture the incoming cards BEFORE append(): append() MOVES the
            // nodes, so querying nextGridElement afterwards returns an empty
            // list — the new cards would then stay stuck at opacity: 0 and
            // infinite scroll would look like it never loaded anything.
            const newCards = [...nextGridElement.children];
            const firstNewIndex = grid.children.length;
            grid.append(...newCards);
            // Continue the global promo cycle across the appended range BEFORE
            // reveal bookkeeping, so the inserted slots are staggered and
            // observed together with the product cards.
            this.insertPromos(firstNewIndex);
            const newChildren = [...grid.children].slice(firstNewIndex);
            if (nextNav) {
              nav.replaceWith(nextNav);
              nextNav.style.display = 'none';
            }

            this.applyRevealStagger(newChildren);
            this.observeRevealTargets(
              newChildren.filter((el) => el.matches('[data-nc-reveal]') && !el.classList.contains('is-visible'))
            );

            if (!this.querySelector('[data-nc-next-link]')) this.destroyInfiniteScroll();
          } catch (error) {
            if (error && error.name !== 'AbortError') {
              // Fall back to the clickable pagination on failure.
              if (nav) nav.style.display = '';
              this.destroyInfiniteScroll();
            }
          } finally {
            this.loadingNextPage = false;
            if (loading) loading.hidden = true;
          }
        }

        openDrawer(trigger) {
          const drawer = this.querySelector('[data-nc-drawer]');
          if (!drawer || !drawer.hidden) return;
          this.drawerTrigger = trigger;
          this.restoreMobileForm();
          drawer.hidden = false;
          document.documentElement.style.overflow = 'hidden';
          // Guarantee initial transform is painted before adding the open class,
          // otherwise the browser may batch and skip the transition.
          void drawer.offsetWidth;
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              drawer.classList.add('is-open');
            });
          });
          setTimeout(() => {
            drawer.querySelector('.nc-filter-drawer__header button')?.focus();
          }, 80);
        }

        closeDrawer(discardDraft) {
          const drawer = this.querySelector('[data-nc-drawer]');
          if (!drawer || drawer.hidden) return;
          if (discardDraft) this.restoreMobileForm();
          const trigger = this.drawerTrigger;
          document.documentElement.style.removeProperty('overflow');
          drawer.classList.remove('is-open');
          const finishClose = () => {
            if (!drawer || !drawer.isConnected) return;
            drawer.hidden = true;
            drawer.removeEventListener('transitionend', onPanelTransitionEnd);
            trigger?.focus();
          };
          const onPanelTransitionEnd = (event) => {
            if (event.propertyName === 'transform' && event.target.classList.contains('nc-filter-drawer__panel')) {
              finishClose();
            }
          };
          drawer.addEventListener('transitionend', onPanelTransitionEnd);
          setTimeout(finishClose, 620);
        }

        restoreMobileForm() {
          const form = this.querySelector('[data-nc-filter-form="mobile"]');
          if (!form) return;
          const params = new URLSearchParams(window.location.search);
          form.querySelectorAll('input').forEach((input) => {
            if (input.type === 'hidden') {
              if (input.name === 'sort_by') input.value = params.get('sort_by') || input.defaultValue;
              return;
            }
            if (input.type === 'checkbox') {
              input.checked = params.getAll(input.name).includes(input.value);
            } else {
              input.value = params.get(input.name) || '';
            }
          });
        }

        clearDraft() {
          const form = this.querySelector('[data-nc-filter-form="mobile"]');
          if (!form) return;
          form.querySelectorAll('input').forEach((input) => {
            if (input.type === 'checkbox') input.checked = false;
            if (input.type !== 'hidden' && input.type !== 'checkbox') input.value = '';
          });
        }

        closeSortMenu() {
          this.querySelectorAll('[data-nc-sort-menu]').forEach((menu) => {
            menu.hidden = true;
          });
          this.querySelectorAll('[data-nc-toggle-sort]').forEach((toggle) => {
            toggle.setAttribute('aria-expanded', 'false');
          });
        }

        updateVariant(swatch) {
          const card = swatch.closest('[data-nc-product-card]');
          const data = card?.querySelector('[data-nc-variants]');
          if (!card || !data) return;
          const variants = JSON.parse(data.textContent);
          const variant = variants.find((item) => String(item.id) === swatch.dataset.ncVariantId);
          if (!variant) return;

          card.querySelectorAll('[data-nc-variant-id]').forEach((button) => {
            const active = button === swatch;
            button.classList.toggle('is-active', active);
            button.setAttribute('aria-pressed', String(active));
          });
          card.querySelectorAll('[data-nc-product-link]').forEach((link) => link.setAttribute('href', variant.url));

          const image = card.querySelector('[data-nc-product-image]');
          if (image && variant.image) {
            image.src = variant.image;
            image.removeAttribute('srcset');
          }

          card.querySelector('[data-nc-price-current]').innerHTML = variant.priceFormatted;
          const compare = card.querySelector('[data-nc-price-compare]');
          const hasDiscount = variant.compareAtPrice > variant.price;
          compare.innerHTML = variant.compareAtPriceFormatted;
          compare.classList.toggle('is-hidden', !hasDiscount);
          const discount = card.querySelector('[data-nc-discount]');
          if (discount) {
            discount.textContent = variant.discountText || '';
            discount.classList.toggle('is-hidden', !hasDiscount);
          }
          const shopLabel = card.querySelector('[data-nc-shop-label]');
          if (shopLabel) shopLabel.textContent = variant.availabilityText;
          card.classList.add('is-variant-selected');
          card.classList.toggle('is-unavailable', !variant.available);
          card.dataset.ncCommittedVariantId = String(variant.id);
        }

        /**
         * IntersectionObserver-driven scroll reveal for product cards and promo
         * slots. Each card gets a staggered delay based on its visual row, so
         * rows flow in rather than popping in all at once.
         */
        initRevealObserver(refresh) {
          if (refresh) this.destroyRevealObserver();

          // Skip entirely when the user has requested reduced motion — we
          // still want to mark targets as visible so no flash/hidden state.
          const reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

          const grid = this.querySelector('[data-nc-products-grid]');
          const allTargets = grid ? [...grid.querySelectorAll('[data-nc-reveal]:not(.is-visible)')] : [];

          if (reducedMotion) {
            allTargets.forEach((el) => el.classList.add('is-visible'));
            return;
          }

          this.applyRevealStagger(grid ? [...grid.children] : []);

          if (!('IntersectionObserver' in window)) {
            allTargets.forEach((el) => el.classList.add('is-visible'));
            return;
          }

          if (!this.revealObserver) {
            this.revealObserver = new IntersectionObserver(
              (entries, observer) => {
                for (const entry of entries) {
                  if (!entry.isIntersecting) continue;
                  entry.target.classList.add('is-visible');
                  observer.unobserve(entry.target);
                }
              },
              {
                // Reveal once the card top passes ~10% above the viewport
                // bottom — feels more responsive than waiting for full rows.
                rootMargin: '0px 0px -10% 0px',
                threshold: 0,
              }
            );
          }

          this.observeRevealTargets(allTargets);
        }

        destroyRevealObserver() {
          if (this.revealObserver) {
            this.revealObserver.disconnect();
            this.revealObserver = null;
          }
        }

        /**
         * Group immediate grid children by their visual row (using vertical
         * position) and assign a per-row stagger delay. Promo cards and
         * product cards are treated the same since they share one grid.
         */
        applyRevealStagger(gridChildren) {
          const rows = new Map();
          const ROW_TOLERANCE = 6;
          for (const child of gridChildren) {
            const top = Math.round(child.getBoundingClientRect().top / ROW_TOLERANCE) * ROW_TOLERANCE;
            if (!rows.has(top)) rows.set(top, rows.size);
            const rowIndex = rows.get(top);
            const revealEl = child.matches('[data-nc-reveal]')
              ? child
              : child.querySelector?.('[data-nc-reveal]');
            if (revealEl) {
              const delay = Math.min(rowIndex * 70, 420);
              revealEl.style.setProperty('--nc-reveal-delay', `${delay}ms`);
            }
          }
        }

        observeRevealTargets(targets) {
          // No observer (reduced motion / unsupported browser) → mark visible
          // immediately so nothing is ever left invisible.
          if (!this.revealObserver) {
            for (const el of targets) el.classList.add('is-visible');
            return;
          }
          for (const el of targets) this.revealObserver.observe(el);
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
